import businessData from "./business-data.json";
import {
  InstagramLogo,
  YoutubeLogo,
  FacebookLogo,
  TwitterLogo,
  TiktokLogo,
  GlobeSimple,
} from "@phosphor-icons/react";

// Business information constants
export const BUSINESS_NAME: string = businessData.business.name;
export const BUSINESS_SHORT_NAME: string = businessData.business.shortName;
export const BASE_URL: string =
  businessData.business.website || "https://streetlawyerservices.com";
export const BUSINESS_DESCRIPTION: string = businessData.business.description;
export const BUSINESS_SLOGAN: string = businessData.business.slogan;
export const BUSINESS_CONTACT_EMAIL: string =
  businessData.business.contact.email;
export const BUSINESS_CONTACT_PHONE: string =
  businessData.business.contact.phone;
export const BUSINESS_ADDRESS: string =
  businessData.business.mainLocation.address.formatted;
export const BUSINESS_HOURS: Record<string, string> =
  businessData.business.contact.hours;
export const BUSINESS_SOCIAL_MEDIA: Record<string, string> =
  businessData.business.socialMedia;
export const BUSINESS_BRANDING = businessData.business.branding;
export const BUSINESS_LEGAL = businessData.business.legal;
export const BUSINESS_SEO = businessData.business.seo;
export const BUSINESS_PRODUCTS = businessData.business.products;
export const BUSINESS_PAYMENTS = businessData.business.payments;

// Social media icon components mapped to their platform names
export const SOCIAL_MEDIA_ICONS = {
  instagram: InstagramLogo,
  youtube: YoutubeLogo,
  facebook: FacebookLogo,
  twitter: TwitterLogo,
  tiktok: TiktokLogo,
  globe: GlobeSimple,
};

// Helper function to get the appropriate icon component for a given platform
export const getSocialIcon = (platform: string) => {
  const platformKey = platform.toLowerCase() as keyof typeof SOCIAL_MEDIA_ICONS;
  return SOCIAL_MEDIA_ICONS[platformKey] || SOCIAL_MEDIA_ICONS.globe;
};
